<template>
  <div class='home'>
    <DeliveryList
      v-show='listView'
      @newDelivery='onClickNewFromList'
      @editDelivery='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <DeliveryForm
      v-show='formView'
      :delivery='delivery'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import DeliveryList from '@/components/delivery/DeliveryList.vue'
import DeliveryForm from '@/components/delivery/DeliveryForm.vue'

export default {
  name: 'Delivery',
  components: {
    DeliveryList,
    DeliveryForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      delivery: {
        id: null,
        deliver_no: null,
        name: null,
        address: null,
        phone: null,
        email: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.delivery = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.delivery = {
        id: null,
        name: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.delivery = {
        id: null,
        name: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getRowTable')
  }
}
</script>
